import { render } from "./SSOCallback.vue?vue&type=template&id=235f9c44&scoped=true"
import script from "./SSOCallback.vue?vue&type=script&lang=js"
export * from "./SSOCallback.vue?vue&type=script&lang=js"

import "./SSOCallback.vue?vue&type=style&index=0&id=235f9c44&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-235f9c44"]])

export default __exports__